import EA from '../helpers/init';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

export default EA.Methods.multimediaGallery = ($this) => {
    const itemGallery = $this.querySelector('.item-gallery');
    const galleryOpener = $this.querySelectorAll('.item-thumbnail');

    let lg = null;

    for (let i = 0; i < galleryOpener.length; i++) {
        galleryOpener[i].addEventListener('click', () => {
            const thumbnails = $this.querySelectorAll('.item-thumbnail');
            thumbnails.forEach(element => {
                element.src = element.dataset.src;
            });        
            if(!lg) {
                lg = lightGallery(itemGallery, {
                    selector: '.item',
                    plugins: [lgZoom, lgThumbnail],
                    thumbnail: false,
                    preload: 1,
                    animateThumb: false,
                    showThumbByDefault: false,
                });
            }
            lg.openGallery(0);
        });
    }
};
